<template>
    <div class="container mt-5">

    <router-link class="btn-back" to="/solutions/echangesemences"><i class="fas fa-long-arrow-alt-left"></i> Retour</router-link>
    <div class="titleProduct"><img src="@/assets/img/BourseEchange.png" class="img-fluid logoProd" alt="Bourse d'Echange"> Echange semences </div>
    <div class="label ml-3">Espace coopératives et négoces</div>
    

    <div class="container mt-5">
        <div class="row">
            <div class="col pt-3">
                <div class="blockTitle">Notre concept</div>
                <div class="columnBlock">
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-search-location"></i></span>
                        Place de marché avec <br> moteur de recherche <br> et alertes
                    </div>
                    <div class="itemRow end">
                        Messagerie instantanée <br> entre acheteur et vendeur
                        <span class="imgTable"><i class="far fa-comments"></i></span>
                    </div>
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-stopwatch"></i></span>
                        Publication d'annonce <br> en quelques secondes 
                    </div>
                    <img src="@/assets/img/illustrations/echange_semences/mockup.png" class="img-fluid imgBottom" alt="">
                </div>
            </div>
            <div class="col">
                <div class="blockTitle">Vos avantages</div>
                <div class="columnBlock">
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-plug"></i></span>
                        Intégration <br> extranet
                    </div>
                    <div class="itemRow end">
                        Traçabilité <br>de bout en bout
                        <span class="imgTable"><i class="fas fa-people-arrows"></i></span>
                    </div>
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-bell"></i></span>
                        Notifications <br> automatisées
                    </div>
                    <div class="itemRow end">
                        Reporting <br> et suivi
                        <span class="imgTable"><i class="fas fa-chart-bar"></i></span>
                    </div>
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-tablet-alt"></i></span>
                        Design <br> "responsive"
                    </div>
                </div>
            </div>
            <div class="col  pt-3">
                <div class="blockTitle">Mise en oeuvre</div>
                <div class="columnBlock">
                    <div class="itemRow start">
                        <span class="imgTable"><i class="fas fa-code"></i></span>
                        Analyse <br> Intégration extranet <br> Design
                    </div>
                    <div class="lineVer"></div>
                    <div class="itemRow end">
                        Import des Excel <br> ou <br> Intégration API
                        <span class="imgTable"><i class="far fa-file-excel"></i></span>
                    </div>
                    <div class="lineVer"></div>
                    <div class="itemRow start">
                        <span class="imgTable"><i class="far fa-thumbs-up"></i></span>
                        Import des données <br> Recette <br> Déploiement
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="titleProduct">Ils utilisent Echange Semences</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/vivescia.png" alt="Logo Vivescia"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/ceresia.png" alt="Logo Ceresia"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/atriumlogo.svg" alt="Logo Atrium"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_novagrain.svg" alt="Logo Novagrain"></div>
    </div>

     <div class="row">
        <div class="col">
            <div class="text-center">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/WxPycRea15I" modestbranding="1" rel="0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
        <div class="col">
            <div class="highlighted">
                Intégrable à l’extranet de la coopérative, cette application web est une plateforme d’annonces pour permettre aux agriculteurs/viticulteurs d’échanger leurs apports livrés par la coopérative, tout en assurant le suivi et la traçabilité des numéros de lots.
            </div>
        </div>
    </div>
    
    <div class="row mt-5 mb-5 text-center">
        <router-link class="btn btn-primary mx-auto" to="/actualites/bourse-vivescia">Témoignage Vivescia </router-link>
    </div>

    <MailjetNewsLetter/>

  </div>
</template>

<script >
    import MailjetNewsLetter from '@/components/MailjetNewsLetter'
    // login: 'novagrin',
    // mdp:'DemoActura2021',
    export default {
        name: 'EchangeSemencesCoop',
        data(){
        return {
            login: '',
            mdp:'',
            hasError:false,
            result:''
        }
        },         
        components:{
            MailjetNewsLetter
        },
        methods:{
            toDap () {
                this.hasError = false
                this.result = ''
                if (!this.login || this.login.trim() === '' || this.mdp.trim() === '' || !this.mdp) {
                this.hasError = true
                this.result = 'Merci de renseigner tous les champs demandés pour envoyer votre demande'
                } else {
                const jeton = window.btoa(unescape(encodeURIComponent("loginTiers="+this.login+"&password=" + this.mdp)));
                const uri = "http://localhost:3000?jetonsso="+jeton;
                const encoded = encodeURI(uri);
                window.open(encoded, '_blank');
                }
            }
        },
        props:{}
    }
</script>

<style lang="scss" scoped>


    iframe{
        border-radius: 20px;
    }

    .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }
    .label{
            background-color: #f0f0f0;
            color: var(--mainBleu);
            font-weight: 600;
            font-size: 25px;
            padding: 10px;
            border-radius: 50px;
            text-align: right;
            margin-bottom: 100px;
        }

    .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }

    .zoomIn {
        transition: transform .2s;
        position: relative;;
        &:hover{
           transform: scale(1.9);
           position: absolute;
           z-index: 10;
        }
    }

    .columnBlock{
        color: white;
        font-weight: 600;
        font-size: 25px;
        background-color: var(--mainBlue);
        padding: 20px;
        border-radius: 18px;
        text-align: center;
        min-height: 500px;
    }

    .blockTitle{
        font-size: 25px;
        font-weight: 500;
        text-align: center;
        padding-bottom: 20px;
    }

    .itemRow{
        font-size: 16px;
        font-weight: 400;
        margin: 15px 0px;
        display: flex;
        align-items: center;
        &.start{
            justify-content: flex-start;
            text-align: start;
        }
        &.end{
            justify-content: flex-end;
            text-align: end;
        }
    }
    .imgTable{
            margin: 10px;
            font-size: 30px;
            color: var(--mainGreen);
        }
    .lineVer{
        border: 2px solid #f2f2f2;
        width: 2px;
        height: 40px;
        display: inline-flex;
        align-items: center;
    }
    .imgBottom{
        border-radius: 7px;
    }


 .featuresList{
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        img{
            padding: 5px;
            margin-bottom: 40px;
        }
    }

    .poductLink{
        background-color: white;
        border: var(--mainBlue) 10px solid;
        border-radius: 20px;
        padding: 30px;
        text-align: center;
    }

     .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }

    .contact-block {
        color: white;
        font-weight: 600;
        font-size: 25px;
        background-color: var(--mainBlue);
        padding: 20px;
        border-radius: 18px;
        text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
        margin: auto;
        border-radius: 25px;
        max-width: 300px;
        height: 45px;
    }
    .button-input{
        background-color: var(--mainGreen);
        color: white;
        position: relative;
        height: 40px;
        top: -42.5px;
        left: 105px;
        z-index: 20;
        &:hover{
            background-color: var(--mainBlue);
        }
    }
    .form-group{
    
      .formLabel{
          font-size: 16px;
          font-weight: 600;
      }
      .form-text{
          font-size: 13px;
          font-weight: 400;
      }
    }

    .result {
        font-weight: 600;
        margin-top: 10px;
        color: var(--mainGreen);
    }
    }
     .logoProd {
        max-height: 120px;
    }
</style>